import { Activity } from "lucide-react";

import type { AIAnalysis } from "../../core";

export default function PortfolioHealth({ analysis, loading }: { analysis: AIAnalysis | null; loading: boolean }) {
	if (loading) return <div className="h-40 rounded-xl border border-zinc-200 bg-white dark:border-zinc-800 dark:bg-zinc-900 animate-pulse" />;
	if (!analysis) return null;

	return (
		<div className="rounded-xl border border-zinc-200 bg-white dark:border-zinc-800 dark:bg-zinc-900 p-6 flex flex-col md:flex-row gap-6 shadow-md">
			<div className="flex flex-col items-center justify-center p-6 bg-zinc-50 rounded-lg border border-zinc-200 dark:bg-zinc-950 dark:border-zinc-800 min-w-37.5">
				<Activity className="text-blue-600 dark:text-blue-400 mb-2" size={32} />
				<span className="text-4xl font-bold text-zinc-950 dark:text-white">{analysis.risk_score}</span>
				<span className="text-xs text-zinc-500 mt-1 uppercase tracking-wider">Risk Score</span>
			</div>
			<div className="flex flex-col justify-center">
				<h3 className="text-xl font-semibold mb-3">Executive Summary</h3>
				<p className="text-zinc-600 dark:text-zinc-300 leading-relaxed">{analysis.health_summary}</p>
			</div>
		</div>
	);
}
